import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchInputModule } from '@shared/components/search-input/search-input.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SvgModule } from '@shared/components/svg/svg.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { MatPaginationCustomModule } from '@shared/components/mat-pagination-custom/mat-pagination-custom.module';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicCatalogFilesComponent } from './dynamic-catalog-files/dynamic-catalog-files.component';
import { CatalogItemService } from '../../../data/modules/catalog-items-data/services/catalog-item.service';

@NgModule({
  declarations: [DynamicCatalogFilesComponent],
  imports: [
    CommonModule,
    SearchInputModule,
    MatPaginatorModule,
    SvgModule,
    MatTooltipModule,
    MatTableModule,
    NgLetModule,
    MatPaginationCustomModule,
    TranslateModule
  ],
  providers: [CatalogItemService]
})
export class DynamicCatalogFilesModule {}
